import React, { useEffect } from 'react'
import Aos from 'aos'

const About = () => {
    useEffect(()=>{
        Aos.init({duration: 2000});
    },[])
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
        <div data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500" className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
            <div className='sm:text-right pb-8 pl-4'>
                <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
                    About
                </p>
            </div>
            <div></div>
            </div>
            <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
                <div className='sm:text-right text-4xl font-bold'>
                    <p>Hi. we are netPrime, nice to meet you. Please take a look around.</p>
                </div>
                <div>
                    <p>netPrime is a team specializing in the design of software using new technologies. Composed of a young and dynamic team that easily adapts to your needs, personalizes your solutions and accompanies you throughout your project, netPrime is committed to providing you with an irreproachable quality service and this by directing these services towards the website creation and software.. What would you do if you had
                    a software expert available at your fingertips?</p>  
                </div>
            </div>
        </div>
  </div>
  )
}

export default About